module.exports = __webpack_public_path__ + "static/media/clouds-sun.8076533f.svg";